'use client'

import React from 'react'

import { useI18n } from '@/shared/providers'
import { ErrorWidget } from '@/widgets/error'
import { NavbarError } from '@/widgets/navbar/navbar-error'

type ErrInternalServerErrorProps = {
    message: string
    digest?: string
}

export function ErrInternalServerError({ message, digest }: ErrInternalServerErrorProps) {
    const { i18n } = useI18n()

    return (
        <React.Fragment>
            <NavbarError />
            {/* NOTE: in production `message` is either a minified React error or a text React redacted
                to avoid leaking server details, so it is only worth showing while developing. The
                digest stays — the server log records it too, which is what support needs. */}
            <ErrorWidget
                statusCode={500}
                title={i18n.TEXT_INTERNAL_SERVER_ERROR}
                message={process.env.NODE_ENV === 'production' ? undefined : message}
                digest={digest}
            />
        </React.Fragment>
    )
}
